import Keycloak from "keycloak-js";

const keycloakClient = new Keycloak({
    "realm": process.env.REACT_APP_KEYCLOAK_REALM,
    "url": process.env.REACT_APP_KEYCLOAK_URL,
    "clientId": process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    "onLoad": "check-sso", // check-sso | login-required
    "KeycloakResponseType": "code",
});

export default keycloakClient;